function copySpecificConversation(answerElement) {
	try {
		// Find the corresponding question for this answer
		var questionElement = findCorrespondingQuestion(answerElement);
		
		if (!questionElement) {
			console.warn('No corresponding question found for this answer');
			return '';
		}
		
		var conversationText = '';
		
		// Get question text
		var questionSpan = questionElement.querySelector('span');
		var questionText = questionSpan ? questionSpan.textContent.trim() : '';
		
		// Get answer text
		var answerContent = answerElement.querySelector('.answer-content');
		var answerText = answerContent ? stripHtmlTags(answerContent.innerHTML).trim() : '';
		
		conversationText += 'User: ' + questionText + '\n\nAI: ' + answerText;
		
		// Check for references in this specific answer
		var referencesSection = answerElement.querySelector('.references-section');
		if (referencesSection) {
			var referenceItems = referencesSection.querySelectorAll('.reference-item');
			if (referenceItems.length > 0) {
				conversationText += '\n\nReferences:\n';
				referenceItems.forEach(function(item, index) {
					var link = item.querySelector('a');
					if (link) {
						var title = link.textContent.trim();
						var url = link.getAttribute('href');
						conversationText += (index + 1) + '. ' + title + ' - ' + url + '\n';
					}
				});
			}
		}
		
		// Check for related articles in this specific answer
		var relatedSection = answerElement.querySelector('.ai-search-related');
		if (relatedSection) {
			var relatedLinks = relatedSection.querySelectorAll('a');
			if (relatedLinks.length > 0) {
				conversationText += '\nRelated Articles:\n';
				relatedLinks.forEach(function(link, index) {
					var title = link.textContent.trim();
					var url = link.getAttribute('href');
					conversationText += '• ' + title + ' - ' + url + '\n';
				});
			}
		}
		
		return conversationText.trim();
	} catch (error) {
		console.error('Error extracting specific conversation:', error);
		return '';
	}
}

function findCorrespondingQuestion(answerElement) {
	// Find the question that corresponds to this answer
	// Questions and answers appear in sequence, so we need to find the question that comes before this answer
	
	var allElements = document.querySelectorAll('.ai-search-question, .ai-search-asking-question, .ai-search-answer');
	var answerIndex = -1;
	
	// Find the index of the current answer element
	for (var i = 0; i < allElements.length; i++) {
		if (allElements[i] === answerElement) {
			answerIndex = i;
			break;
		}
	}
	
	if (answerIndex === -1) {
		return null;
	}
	
	// Look backwards from the answer to find the corresponding question
	for (var j = answerIndex - 1; j >= 0; j--) {
		var element = allElements[j];
		if (element.classList.contains('ai-search-question') || element.classList.contains('ai-search-asking-question')) {
			return element;
		}
	}
	
	return null;
}

function stripHtmlTags(html) {
	// Create a temporary div to strip HTML tags
	var tempDiv = document.createElement('div');
	tempDiv.innerHTML = html;
	
	// First, preserve citation numbers by converting citation circles to square brackets
	// Handle citation circles like <a class="citation-circle" href="...">1</a>
	tempDiv.innerHTML = tempDiv.innerHTML.replace(/<span[^>]*class="citation-circle"[^>]*>(\d+)<\/span>/gi, '[$1]');
	
	// Replace <br> tags with line breaks
	tempDiv.innerHTML = tempDiv.innerHTML.replace(/<br\s*\/?>/gi, '\n');
	
	// Replace </p> tags with double line breaks
	tempDiv.innerHTML = tempDiv.innerHTML.replace(/<\/p>/gi, '\n\n');
	
	// Replace list items with bullet points
	tempDiv.innerHTML = tempDiv.innerHTML.replace(/<li>/gi, '• ');
	tempDiv.innerHTML = tempDiv.innerHTML.replace(/<\/li>/gi, '\n');
	
	// Get text content and clean up extra whitespace
	var text = tempDiv.textContent || tempDiv.innerText || '';
	
	// Clean up multiple consecutive line breaks
	text = text.replace(/\n\s*\n\s*\n/g, '\n\n');
	
	return text.trim();
}

function handleCopyConversation(event) {
	var copyButton = event.target;
	
	// Find the answer element that contains this copy button
	var answerElement = copyButton.closest('.ai-search-answer');
	
	if (!answerElement) {
		console.warn('Copy button not found within an answer element');
		return;
	}
	
	var conversationText = copySpecificConversation(answerElement);
	
	if (!conversationText) {
		console.warn('No conversation content to copy');
		return;
	}
	
	// Try modern clipboard API first
	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(conversationText).then(function() {
			showCopyFeedback(copyButton);
			// Track copy event
			if (typeof wmdTrack !== 'undefined') {
				wmdTrack('ai-search_copy-conversation', copyButton);
			}
		}).catch(function(error) {
			console.error('Failed to copy using clipboard API:', error);
			// Fallback to legacy method
			fallbackCopyToClipboard(conversationText, copyButton);
		});
	} else {
		// Fallback for older browsers
		fallbackCopyToClipboard(conversationText, copyButton);
	}
}

function fallbackCopyToClipboard(text, copyButton) {
	try {
		// Create a temporary textarea element
		var textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.left = '-999999px';
		textArea.style.top = '-999999px';
		document.body.appendChild(textArea);
		
		// Select and copy the text
		textArea.focus();
		textArea.select();
		
		var successful = document.execCommand('copy');
		document.body.removeChild(textArea);
		
		if (successful) {
			showCopyFeedback(copyButton);
			// Track copy event
			if (typeof wmdTrack !== 'undefined') {
				wmdTrack('ai-search_copy-conversation', copyButton);
			}
		} else {
			console.error('Failed to copy using fallback method');
		}
	} catch (error) {
		console.error('Fallback copy failed:', error);
	}
}

function showCopyFeedback(copyButton) {
	// Store original text
	var originalText = copyButton.textContent;
	
	// Show "Copied" feedback
	copyButton.textContent = 'Copied!';
	copyButton.classList.add('copied');
	
	// Reset after 1 second
	setTimeout(function() {
		copyButton.textContent = originalText;
		copyButton.classList.remove('copied');
	}, 1000);
}


module.exports = {
	copySpecificConversation: copySpecificConversation,
	handleCopyConversation: handleCopyConversation
};
